import * as _ from 'lodash';
import { ICalendarStateAction } from "@adage/ace-calendar";
import { ExtendedActionType } from "../actions";
import { ICalendarText, emptyCalendarTextInterface } from '../../classes/index';

export interface ICalendarTextState {
    updating: boolean;
    text: ICalendarText;
}

export const defaultCalendarTextState: ICalendarTextState = {
    updating: false,
    text: emptyCalendarTextInterface
}

export default function calendarTextReducer(state: ICalendarTextState = defaultCalendarTextState, action: ICalendarStateAction) {
    switch (action.type) {
        case ExtendedActionType.ReceiveCalendarText: {
            return _.assign({}, state, { updating: false, text: action.value });
        }
        case ExtendedActionType.RequestCalendarText: {
            return _.assign({}, state, { updating: true });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/reducers/calendar-text-reducer.ts